module.exports = "<div id=\"rebar\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/sketch/rebars/rebars.component.html
// module id = 56
// module chunks = 0